/*
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-10 17:18:44
 * @Reference:
 */
export schema from './schema'
export model from './model'
export hook from './hook'
export menus from './menus'
export config from '@/config'
export router from '@/router'
console.log(2882 + '修改model 后请修改我')
